<template>
  <!-- Which commit the server runs, in the corner of the Süsteem pages
       (SystemFrame.vue, both looks). Admin and root only. -->
  <v-menu v-if="version" location="bottom end" :close-on-content-click="false">
    <template #activator="{ props: menu }">
      <button type="button" class="sys-ver" v-bind="menu" :title="'Versioon ' + (version.short || '?') + ' — klõpsa detailide jaoks'">
        <span class="sys-ver-dot" :class="'sys-ver-dot--' + version.instance" aria-hidden="true"></span>
        <span class="sys-ver-env">{{ version.instance }}</span>
        <span class="sys-ver-sha">{{ version.short || 'git puudub' }}</span>
        <span v-if="version.committedAt">· {{ day(version.committedAt) }}</span>
      </button>
    </template>
    <div class="sys-ver-pop" role="dialog" aria-label="Versioon">
      <div class="sys-ver-pop-head">
        <span class="sys-ver-dot" :class="'sys-ver-dot--' + version.instance" aria-hidden="true"></span>
        <strong>Versioon</strong>
        <span class="sys-ver-pop-env">{{ version.instance }}</span>
      </div>
      <dl>
        <dt>Commit</dt><dd class="sys-ver-sha">{{ version.short || '—' }}</dd>
        <template v-if="version.subject"><dt>Muudatus</dt><dd>{{ version.subject }}</dd></template>
        <template v-if="version.committedAt"><dt>Commiti aeg</dt><dd>{{ time(version.committedAt) }}</dd></template>
        <template v-if="version.branch"><dt>Haru</dt><dd>{{ version.branch }}</dd></template>
        <dt>Server käivitus</dt><dd>{{ time(version.startedAt) }}</dd>
      </dl>
      <div class="sys-ver-pop-foot">
        <button type="button" class="sys-ver-copy" :disabled="!version.commit" @click="copy">{{ copied ? 'Kopeeritud' : 'Kopeeri' }}</button>
      </div>
    </div>
  </v-menu>
</template>

<script>
import dayjs from 'dayjs'
import api from '@/api'

export default {
  data: () => ({
    version: null,
    copied: false
  }),
  async created () {
    if (!this.$hasRole(['admin', 'root'])) return
    try {
      this.version = await api.getVersion()
    } catch (err) {
      // No tag is better than an error over a page that works.
    }
  },
  methods: {
    day: value => dayjs(value).format('DD.MM.YYYY'),
    time: value => dayjs(value).format('DD.MM.YYYY HH:mm'),
    async copy () {
      const v = this.version
      const text = [v.instance, v.commit, v.subject].filter(Boolean).join(' ')
      try {
        await navigator.clipboard.writeText(text)
        this.copied = true
        setTimeout(() => { this.copied = false }, 2000)
      } catch (err) {
        // A browser without clipboard access: the commit is on screen anyway.
      }
    }
  }
}
</script>
